import Vue from 'vue';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { CLEAR_REQUEST_ERRORS } from 'src/store/types';
export default Vue.extend({
    props: {
        hasSidebar: { type: Boolean, default: false }
    },
    computed: {
        ...mapGetters(['currentSite', 'hasRequestErrors', 'serverErrors', 'hasConnectionErrors']),
        showErrors() {
            return this.hasRequestErrors && this.serverErrors.length > 0;
        }
    },
    watch: {
        // We debounce the watcher to account for the fact that custom error
        // handling at the component level works by clearing the store errors;
        // when that happens this watcher will be triggered again and we won't
        // want to register an unhandled error (the second call will override
        // the first).
        showErrors: debounce(function (isShown) {
            if (isShown) {
                this.hasConnectionErrors
                    ? this.$analytics.track.connectionError()
                    : this.$analytics.track.errorUnhandled(this.serverErrors);
            }
        }, 100)
    },
    methods: {
        clearErrors() {
            this.$store.dispatch(CLEAR_REQUEST_ERRORS);
        }
    },
});
